import { render, staticRenderFns } from "./RightButtons.vue?vue&type=template&id=763ae5f2&"
import script from "./RightButtons.vue?vue&type=script&lang=js&"
export * from "./RightButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports